export default __webpack_public_path__ + "static/media/funic.e6a1bf44.png";